export const BRAZE_ANONYMOUS_ALIAS_LABEL = 'dtc_anonymous';
export const BRAZE_ANONYMOUS_ID_STORAGE_KEY = 'braze_anonymous_id';
